import { axios, Response } from '../index'

const moveGroupFiles = (
  filesIds: string[],
  destinyFolderId: string
): Response<null> => {
  return axios.put(`/v1/files/move-to/${destinyFolderId}`, { filesIds })
}

export default moveGroupFiles
